class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.addEventListener('openCartDrawer', () => this.open());
    // Listen for global events
    window.addEventListener('openCartDrawer', () => this.open());
    this.setHeaderCartIconAccessibility();

    /* SMRDTC-2637 */
    // window.addEventListener('pageshow', (event) => {
    //   if (event.persisted && typeof window._cartRefresh === 'function') {
    //     window._cartRefresh();
    //   }
    // });
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) window.location.reload();
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    localStorage.removeItem('spanDrawerVisible');
    window.__isMiniCartOpen = true;
    const spanDrawer = document.querySelector('.initial-count-units-drawer');
    if (spanDrawer) {
      spanDrawer.style.display = 'none';
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    
    // Hide background content from screen readers (VoiceOver accessibility fix for iOS)
    this.hideBackgroundFromScreenReaders();

    this.toggleAttribute('data-stylitics-enabled', !!window.STYLITICS_CLIENT);
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      requestAnimationFrame(() => {
        if (!window.__enableStyliticsMiniCart) return;
        initStyliticsInMiniCart(this);
      });
      requestIdleCallback(() => {
        const dataBrand = document.querySelector('html')?.getAttribute('data-brand');
        const dataLocale = document.querySelector('html')?.getAttribute('data-locale');

        if (dataBrand) {
          const widgetScript = document.createElement('script');
          widgetScript.src =
            'https://static-recommendations.fastsimon.com/no-code-recommendations/fs-recommendations-init.js?uuid=' +
            window.FS_UUID +
            '&store_id=' +
            window.FS_STORE_ID +
            '&platform=Shopify&widgetId=' +
            window.FS_WIDGET_ID +
            '&v=' +
            Date.now();
          document.head.appendChild(widgetScript);
        }
      });
    });
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        
        // Immediately move focus to the drawer container for screen readers
        const drawerInner = this.querySelector('.drawer__inner');
        if (drawerInner) {
          drawerInner.focus();
        }
        
        // Get focusable elements immediately
        const getFocusables = () => Array.from(
          containerToTrapFocusOn.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
          )
        );
        
        let focusableElements = getFocusables();
        if (focusableElements.length === 0) return;
        
        // Set up focusin listener to trap focus IMMEDIATELY (no delay)
        const focusinHandler = (event) => {
          const isInsideDrawer = containerToTrapFocusOn.contains(event.target);
          
          // If focus goes outside drawer, bring it back to first focusable
          if (!isInsideDrawer && this.classList.contains('active')) {
            event.preventDefault();
            focusableElements = getFocusables(); // Refresh in case DOM changed
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
          }
        };
        
        // Set up Tab key handler for cycling within drawer
        const keydownHandler = (event) => {
          if (event.code.toUpperCase() !== 'TAB') return;
          if (!this.classList.contains('active')) return;
          
          focusableElements = getFocusables(); // Refresh in case DOM changed
          const firstFocusable = focusableElements[0];
          const lastFocusable = focusableElements[focusableElements.length - 1];
          const activeElement = document.activeElement;
          
          // If on last element and tabbing forward, go to first
          if (activeElement === lastFocusable && !event.shiftKey) {
            event.preventDefault();
            firstFocusable.focus();
          }
          
          // If on first element and tabbing backward, go to last
          if (activeElement === firstFocusable && event.shiftKey) {
            event.preventDefault();
            lastFocusable.focus();
          }
        };
        
        // Store handlers for cleanup
        this.focusTrapHandler = keydownHandler;
        this.focusinTrapHandler = focusinHandler;
        
        // Add listeners immediately
        document.addEventListener('keydown', keydownHandler);
        document.addEventListener('focusin', focusinHandler);
        
      },
      { once: true }
    );

    // Set up focus trapping for accessibility
    const setupFocusTrap = () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
      
      // Trap focus within the cart drawer for keyboard navigation accessibility
      if (containerToTrapFocusOn && focusElement) {
        trapFocus(containerToTrapFocusOn, focusElement);
      }
      
    };

    // Listen for transition end to set up focus trap
    this.addEventListener('transitionend', setupFocusTrap, { once: true });

    // Fallback: if transition doesn't fire within 500ms, set up focus trap anyway
    setTimeout(() => {
      if (this.classList.contains('active')) {
        setupFocusTrap();
      }
    }, 500);

    clearTimeout(this.cartAnnouncementOpenTimeout);
      this.lastCartAnnouncement = '';

      this.cartAnnouncementOpenTimeout = setTimeout(() => {
        if (this.classList.contains('active')) {
          this.updateCartAnnouncement();
        }
    }, 1200);

    document.body.classList.add('overflow-hidden');
  }

  updateCartAnnouncement() {
    const announceDiv = document.getElementById('CartDrawer-Announce');
    if (!announceDiv) {
      return;
    }
    
    // Wait longer for shipping progress to populate (it runs async)
    setTimeout(() => {
      // 1. Get cart count from drawer__count
      const itemCountElement = document.getElementById('CartDrawer-ItemCount');
      const itemCount = itemCountElement ? itemCountElement.textContent.trim() : '0';
      const itemWord = itemCount === '1' ? 'item' : 'items';
      const cartText = `Your cart has ${itemCount} ${itemWord}.`;
      
      // 2. Get shipping message
      const shippingMsg = document.getElementById('CartShippingProgressMsg');
      const rawShippingText = shippingMsg ? shippingMsg.textContent.trim() : '';
      // Only add shipping text if it's not empty and not just whitespace
      const shippingText = rawShippingText && rawShippingText.length > 0 ? rawShippingText + '.' : '';
      
      // 3. Get estimated total
      const totalValue = document.querySelector('.totals__total-value');
      const totalText = totalValue ? `Estimated total ${totalValue.textContent.trim()}.` : '';
      
      // Build the full announcement - filter out empty strings
      const parts = [cartText, shippingText, totalText].filter(text => text && text.trim().length > 0);
      const fullAnnouncement = parts.join(' ');
      
      // Update the announcement div
      announceDiv.textContent = fullAnnouncement;
    }, 600); // Wait 600ms for shipping progress to populate
  }

  close() {
    window.__isMiniCartOpen = false;
    localStorage.removeItem('spanDrawerVisible');
    const spanDrawer = document.querySelector('.initial-count-units-drawer');
    if (spanDrawer) {
      spanDrawer.style.display = 'none';
    }
    this.classList.remove('active');
    
    // Remove custom focus trap handlers
    if (this.focusTrapHandler) {
      document.removeEventListener('keydown', this.focusTrapHandler);
      this.focusTrapHandler = null;
    }
    if (this.focusinTrapHandler) {
      document.removeEventListener('focusin', this.focusinTrapHandler);
      this.focusinTrapHandler = null;
    }
    
    // Restore background visibility for screen readers
    this.showBackgroundToScreenReaders();
    
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const cartDrawerSectionId = this.getCartDrawerSectionId();

    return [
      {
        id: cartDrawerSectionId,
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getCartDrawerSectionId() {
    if (!this.classList.contains('drawer--kg')) return 'cart-drawer';

    const sectionContainer = this.closest('.shopify-section[id]');
    if (!sectionContainer) return 'cart-drawer';

    const sectionId = sectionContainer.id.replace(/^shopify-section-/, '');
    return sectionId || 'cart-drawer';
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  hideBackgroundFromScreenReaders() {
    // Get all elements that should be hidden from screen readers when cart drawer is open
    const elementsToHide = [
      document.getElementById('MainContent'),
      document.querySelector('.header-wrapper'),
      document.querySelector('header'),
      document.querySelector('footer'),
      document.querySelector('.shopify-section-group-header-group'),
      document.querySelector('.shopify-section-group-footer-group')
    ].filter(Boolean); // Remove null/undefined elements

    // Store the elements for later restoration
    this.hiddenElements = elementsToHide;

    // Set aria-hidden on each element
    elementsToHide.forEach(element => {
      element.setAttribute('aria-hidden', 'true');
    });
  }

  showBackgroundToScreenReaders() {
    // Restore visibility to screen readers
    if (this.hiddenElements) {
      this.hiddenElements.forEach(element => {
        element.removeAttribute('aria-hidden');
      });
      this.hiddenElements = null;
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartDrawerSectionId =
      cartDrawer && typeof cartDrawer.getCartDrawerSectionId === 'function'
        ? cartDrawer.getCartDrawerSectionId()
        : 'cart-drawer';

    return [
      {
        id: 'CartDrawer',
        section: cartDrawerSectionId,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// ---- Stylitics Mini Cart (Composer) ----
const STYLITICS_COMPOSER_SRC = "https://web-assets.stylitics.com/loader/latest/composer.js";

function loadStyliticsComposerOnce() {
  if (window.__styliticsComposerPromise) return window.__styliticsComposerPromise;

  window.__styliticsComposerPromise = new Promise((resolve, reject) => {
    if (window.StyliticsComposer?.initialize) return resolve(true);

    const existing = document.querySelector('script[data-stylitics-composer="true"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(true), { once: true });
      existing.addEventListener("error", reject, { once: true });
      return;
    }

    const s = document.createElement("script");
    s.src = STYLITICS_COMPOSER_SRC;
    s.async = true;
    s.defer = true;
    s.dataset.styliticsComposer = "true";
    s.onload = () => resolve(true);
    s.onerror = reject;
    document.head.appendChild(s);
  });

  return window.__styliticsComposerPromise;
}

async function fetchCart() {
  const res = await fetch("/cart.js", { credentials: "same-origin" });
  if (!res.ok) throw new Error("Failed to fetch /cart.js");
  return res.json();
}

function mapToStyliticsItemNumber(cartItem) {
  if (!cartItem) return "";

  // 1) UPC
  const upc = String(cartItem?.properties?.UPC || "").trim();
  if (upc) return upc;

  // 2) SKU + Color Code
  const sku = String(cartItem.sku || "").trim();
  const colorCode =
    String(cartItem?.options_with_values?.find(o => o.name === "Color Code")?.value || "").trim() ||
    String(cartItem?.variant_options?.[2] || "").trim();

  if (sku && colorCode) return `${sku}_${colorCode}`;

  // 3) Fallback handle
  const handle = String(cartItem.handle || cartItem.product_handle || "").trim();
  if (handle) return handle;

  // 4) Last fallback URL
  const url = cartItem.url || "";
  const m = url.match(/\/products\/([^?\/]+)/);
  if (m?.[1]) return m[1];

  return "";
}

function getFsFallbackEl(drawerRoot) {
  // fast-simon-<timestamp>
  return drawerRoot?.querySelector('[class^="fast-simon-"], [class*="fast-simon-"]');
}

function setFsFallbackVisible(drawerRoot, visible) {
  const el = getFsFallbackEl(drawerRoot);
  if (!el) return;
  el.style.display = visible ? "" : "none";
}

function setStyliticsVisible(drawerRoot, visible) {
  const block = drawerRoot?.querySelector('[data-stylitics]');
  if (!block) return;
  block.style.display = visible ? "" : "none";
}

function isRowClearance(rowEl) {
  // data-is-clearance="true"
  return rowEl && String(rowEl.dataset?.isClearance) === "true";
}

function findRowForVariant(drawerRoot, variantId) {
  if (!variantId) return null;
  return drawerRoot.querySelector(`.cart-item[data-variant-id="${variantId}"], tr.cart-item[data-variant-id="${variantId}"]`);
}

function setStyliticsMode(drawerRoot, mode) {
  // mode: "stylitics" | "fallback"
  if (!drawerRoot) return;

  drawerRoot.toggleAttribute("data-stylitics-enabled", !!window.STYLITICS_CLIENT);

  if (mode === "stylitics") {
    drawerRoot.setAttribute("data-stylitics-active", "true");
  } else {
    drawerRoot.removeAttribute("data-stylitics-active");
  }
}

function getCartItemNumbers(cart, { max = 6 } = {}) {
  const items = cart?.items || [];
  const out = [];
  const seen = new Set();

  const lastId = Number(window.__lastAddedVariantId || 0);
  const lastItem = lastId ? items.find(it => Number(it.variant_id) === lastId) : null;

  if (lastItem) {
    const n = mapToStyliticsItemNumber(lastItem);
    if (n) { seen.add(n); out.push(n); }
  }

  for (const it of items) {
    const n = mapToStyliticsItemNumber(it);
    if (!n || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
    if (out.length >= max) break;
  }

  return out;
}

async function initStyliticsInMiniCart(drawerRoot) {
  if (!drawerRoot) return;
  if (!window.STYLITICS_CLIENT) return;

  const block = drawerRoot.querySelector('[data-stylitics]');
  const targetEl = drawerRoot.querySelector('[data-stylitics-target]');
  if (!block || !targetEl) return;

  const visible = !!(targetEl.offsetWidth || targetEl.offsetHeight || targetEl.getClientRects().length);
  if (!visible) return;

  setFsFallbackVisible(drawerRoot, false);
  setStyliticsVisible(drawerRoot, true);

  try {
    const cart = await fetchCart();
    const itemNumbers = getCartItemNumbers(cart, { max: 3 });

    // Clearance gate:
    const lastId = Number(window.__lastAddedVariantId || 0);
    const anchorRow = findRowForVariant(drawerRoot, lastId);
    const anchorIsClearance = isRowClearance(anchorRow);

    if (anchorIsClearance) {
      // No Stylitics -> FS fallback
      setStyliticsMode(drawerRoot, "fallback");
      setStyliticsVisible(drawerRoot, false);
      setFsFallbackVisible(drawerRoot, true);
      targetEl.dataset.styliticsMounted = "false";
      targetEl.dataset.styliticsItem = "";
      return;
    }

    // Try Stylitics
    await loadStyliticsComposerOnce();

    const item_number = itemNumbers.join(",");

    if (!item_number) {
      // No anchor -> fallback
      setStyliticsMode(drawerRoot, "fallback");
      setStyliticsVisible(drawerRoot, false);
      setFsFallbackVisible(drawerRoot, true);
      targetEl.dataset.styliticsMounted = "false";
      targetEl.dataset.styliticsItem = "";
      return;
    }

    // show Stylitics and hide FS while loads
    setFsFallbackVisible(drawerRoot, false);
    setStyliticsVisible(drawerRoot, true);

    // Avoid unnecessary re-init if same item_number already rendered
    const lastRendered = targetEl.dataset.styliticsItem;
    if (targetEl.dataset.styliticsMounted === "true" && lastRendered === item_number) return;

    if (!targetEl.id) targetEl.id = `stylitics-composer-${Math.random().toString(16).slice(2)}`;
    targetEl.innerHTML = "";

    targetEl.dataset.styliticsItem = item_number;
    targetEl.dataset.styliticsMounted = "true";

    setStyliticsMode(drawerRoot, "stylitics");
    setStyliticsVisible(drawerRoot, true);
    setFsFallbackVisible(drawerRoot, false);

    const timerKey = "__styliticsFallbackTimer";

    if (targetEl[timerKey]) clearTimeout(targetEl[timerKey]);
    targetEl[timerKey] = null;

    const composer = await window.StyliticsComposer.initialize({
      client: window.STYLITICS_CLIENT,
      target: targetEl.id,
      config: {
        modules: [
          {
            type: "classic",
            params: {
              api: { item_number, min: 0, max: 12 },
              display: { hideAnchorItem: false }
            }
          }
        ],

        on: {
          "load.data": (data) => {
            const timerKey = "__styliticsFallbackTimer";

            // Cancel previous fallback timer if data loads successfully with items/outfits to show
            if (targetEl[timerKey]) clearTimeout(targetEl[timerKey]);
            targetEl[timerKey] = null;

            const itemsLen = Array.isArray(data?.items) ? data.items.length : 0;
            const outfitsLen = Array.isArray(data?.outfits) ? data.outfits.length : 0;

            // Keep showing Stylitics if it has data to show
            if (itemsLen > 0 || outfitsLen > 0) {
              setStyliticsMode(drawerRoot, "stylitics");
              setStyliticsVisible(drawerRoot, true);
              setFsFallbackVisible(drawerRoot, false);
              return;
            }

            // Wait a bit for data to load
            targetEl[timerKey] = setTimeout(() => {
              const stillItemsLen = Array.isArray(data?.items) ? data.items.length : 0;
              const stillOutfitsLen = Array.isArray(data?.outfits) ? data.outfits.length : 0;

              const shouldFallback = data?.hidden === true || (stillItemsLen === 0 && stillOutfitsLen === 0);

              if (shouldFallback) {
                setStyliticsMode(drawerRoot, "fallback");
                setStyliticsVisible(drawerRoot, false);
                setFsFallbackVisible(drawerRoot, true);
              }
            }, 800);
          },

          "error": () => {
            setStyliticsMode(drawerRoot, "fallback");
            setStyliticsVisible(drawerRoot, false);
            setFsFallbackVisible(drawerRoot, true);
          }
        },

        sharedParams: { analytics: { placement: "mini-cart" } },

        override: {
          "click.item": (payload) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: "stylitics item click", styliticsData: payload, _clear: true });

            const affiliateLink = payload?.item?.affiliate_link;
            const productPath = getProductPathFromAffiliateLink(affiliateLink);
            const quickViewUrl = buildQuickViewUrlFromProductPath(productPath);
            if (!quickViewUrl) return;

            window.addToCartLocationOverride = "Stylitics";
            openQuickViewFromProductUrl(quickViewUrl);
          }
        }
      }
    });

    await composer.start();

  } catch (e) {
    console.warn("[Stylitics mini-cart] init failed:", e);
    // Error → fallback FS
    setStyliticsMode(drawerRoot, "fallback");
    setStyliticsVisible(drawerRoot, false);
    setFsFallbackVisible(drawerRoot, true);
    const targetEl = drawerRoot.querySelector('[data-stylitics-target]');
    if (targetEl) targetEl.dataset.styliticsMounted = "false";
    const timerKey = "__styliticsFallbackTimer";
    if (targetEl?.[timerKey]) clearTimeout(targetEl[timerKey]);
  }
}

(function bindStyliticsCartUpdated() {
  if (window.__styliticsCartUpdatedBound) return;
  window.__styliticsCartUpdatedBound = true;

  document.addEventListener('cart:updated', () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;

    let tries = 0;
    const tick = () => {
      tries++;
      initStyliticsInMiniCart(drawer);
      if (tries < 6) setTimeout(tick, 80);
    };

    setTimeout(tick, 0);
  });
})();



// Quick View Stylitics
function getProductPathFromAffiliateLink(affiliateLink) {
  if (!affiliateLink) return null;
  const idx = affiliateLink.indexOf("/products/");
  if (idx === -1) return null;
  const tail = affiliateLink.slice(idx + "/products/".length).split("?")[0];
  return "/products/" + tail;
}

function buildQuickViewUrlFromProductPath(productPath) {
  if (!productPath) return null;
  const localePrefix = window.__localePrefix || "";
  return `${localePrefix}${productPath}?view=quick_view`;
}

function openQuickViewFromProductUrl(quickViewUrl) {
  if (!quickViewUrl) return;

  $.get(quickViewUrl, function (data) {
    $(".product_quickview").html(data);
    $(".product_quickview, .overlay").addClass("active");
    $("body").addClass("Fixed");

    if (typeof slider_settings !== "undefined") {
      $("#quick-view-carousel").slick(slider_settings);
    }

    setTimeout(() => $(".main-quick").focus(), 100);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "quick_view_open", _clear: true });
  });
}
